import WSAccessLayerEpic from './WSAccessLayer/epic';
import LoginEpic from './Login/epic';
import ClassroomEpic from './Classroom/epic';
import LayoutEpic from './Layout/epic';
import ExerciseStatEpic from './Exercise/Statistics/epic';
import ExerciseEpic from './Exercise/epic';
import CheckinEpic from './Checkin/epic';
import FinishEpic from './Finish/epic';
import QuestionnaireEpic from './Questionnaire/epic';
import CallrollEpic from './Callroll/epic';
import PostEpic from './Post/epic';
import AnnouncementEpic from './Announcement/epic';
import LessonPlanEpic from './LessonPlan/epic';

export default [
  ...WSAccessLayerEpic,
  ...LoginEpic,
  ...ClassroomEpic,
  ...LayoutEpic,
  ...ExerciseEpic,
  ...ExerciseStatEpic,
  ...CheckinEpic,
  ...FinishEpic,
  ...QuestionnaireEpic,
  ...CallrollEpic,
  ...PostEpic,
  ...AnnouncementEpic,
  ...LessonPlanEpic,
];
